import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';
import { useState } from 'react';

interface GoogleAuthButtonProps {
  loading?: boolean;
  onSuccess: (response: CredentialResponse) => void;
  text: string;
}

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({
  loading = false,
  onSuccess,
  text,
}) => {
  const [error] = useState('');

  const buttonStyle: React.CSSProperties = {
    pointerEvents: loading ? 'none' : 'auto',
    borderRadius: '9999px',
    display: 'flex',
    position: 'relative',
    cursor: loading ? 'not-allowed' : 'pointer',
    border: '1px solid #e5e7eb',
    backgroundColor: 'transparent',
    fontSize: '0.875rem',
    fontWeight: 'bold',
    color: '#374151',
    justifyContent: 'space-between',
    alignItems: 'center',
    textTransform: 'uppercase',
    padding: '0.5rem 0.75rem',
    width: '100%',
    transition: 'all 0.2s ease-in-out',
    transform: loading ? 'scale(0.98)' : 'scale(1)',
    opacity: loading ? 0.7 : 1,
  };

  const googleLoginStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    top: '0',
    left: '0',
    opacity: '0',
  };

  const iconContainerStyle: React.CSSProperties = {
    width: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const loadingIconStyle: React.CSSProperties = {
    marginLeft: '0.5rem',
    animation: 'spin 1s linear infinite',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const errorStyle: React.CSSProperties = {
    fontSize: '0.875rem',
    color: '#ef4444',
    marginTop: '0.25rem',
    transition: 'all 0.3s ease-in-out',
    opacity: error ? 1 : 0,
    transform: error ? 'translateY(0)' : 'translateY(-10px)',
  };

  return (
    <div>
      <div style={buttonStyle}>
        <div style={googleLoginStyle}>
          <GoogleLogin onSuccess={onSuccess} />
        </div>
        <div style={iconContainerStyle}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.6 10.2273C19.6 9.51818 19.5364 8.83636 19.4182 8.18182H10V12.05H15.3818C15.15 13.3 14.4455 14.3591 13.3864 15.0682V17.5773H16.6182C18.5091 15.8364 19.6 13.2727 19.6 10.2273Z" fill="#4285F4"/>
            <path d="M10 20C12.7 20 14.9636 19.1045 16.6182 17.5773L13.3864 15.0682C12.4909 15.6682 11.3455 16.0227 10 16.0227C7.39545 16.0227 5.19091 14.2636 4.40455 11.9H1.06364V14.4909C2.70909 17.7591 6.09091 20 10 20Z" fill="#34A853"/>
            <path d="M4.40455 11.9C4.20455 11.3 4.09091 10.6591 4.09091 10C4.09091 9.34091 4.20455 8.7 4.40455 8.1V5.50909H1.06364C0.386364 6.85909 0 8.38636 0 10C0 11.6136 0.386364 13.1409 1.06364 14.4909L4.40455 11.9Z" fill="#FBBC05"/>
            <path d="M10 3.97727C11.4682 3.97727 12.7864 4.48182 13.8227 5.47273L16.6909 2.60455C14.9591 0.990909 12.6955 0 10 0C6.09091 0 2.70909 2.24091 1.06364 5.50909L4.40455 8.1C5.19091 5.73636 7.39545 3.97727 10 3.97727Z" fill="#EA4335"/>
          </svg>
        </div>
        <div>{text}</div>
        <div style={iconContainerStyle}>
          {loading && (
            <div style={loadingIconStyle}>
              <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></div>
            </div>
          )}
        </div>
      </div>
      <div style={errorStyle}>{error}</div>
    </div>
  );
};
